import '../../../../src/_template/assets/sass/style.scss'
import '../../../_template/asset_2/css/all.min.css';
import '../../../_template/asset_2/css/swiper-bundle.min.css';
import '../../../_template/asset_2/css/meanmenu.min.css';
import '../../../_template/asset_2/css/magnific-popup.css';
import '../../../_template/asset_2/css/master-online-meeting.css';
import '../../../_template/asset_2/css/tvailanding.css';
import '../../../_template/asset_2/css/master-ai-software.css';
import '../../../_template/asset_2/css/master-ai-chatbot.css';
import '../../../_template/asset_2/css/master-integration.css';
import '../../../_template/asset_2/css/master-ai-content-writer.css';
import '../../../_template/asset_2/css/master-ai-image-generator.css';
import './style/landing.css'

import React, {useEffect} from 'react'
import { useLocation } from 'react-router-dom';
import {
    Section_1,
    Section_2,
    TruVoicePlatform,
    FullyManaged,
    CustomBuilt,
    LanguageModels,
    FreeTrial,
    OurPartners
} from './component';
const Landing = () => {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1));
            if (element) {
                const elementTop = element.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: elementTop - 100,
                    behavior: 'smooth'
                });
            }
        }
    }, [location]);
    return (
        <>
            <style>
                {
                    `
                        .hero-area-background {
                            content: "";
                            width: 100%;
                            height: 7%;
                            inset-inline-start: 0px;
                            top: 0px;
                            background: linear-gradient(180deg,rgb(235, 238, 255) 0%, rgba(255, 255, 255, 0.97) 100%);
                            z-index: -1;
                        }
                    `
                }
            </style>
            <main>
                <section className="hero-area">
                    <Section_1 />
                </section>
                <section className="process-area section-spacing pb-10">
                    <Section_2 />
                </section>
                <section id="platform" className='pb-0 pt-0'>
                    <div className="video-features-area section-spacing pb-10">
                        <TruVoicePlatform />
                    </div>
                </section>
                <section className="" id="fully-managed">
                    <div className='sec-3-features-area section-spacing pb-10'>
                        <FullyManaged/>
                    </div>
                </section>
                <section className=" pb-0 pt-0" id="virtual-agents">
                    <div className='fact-area section-spacing pb-10'>
                        <CustomBuilt/>
                    </div>
                </section>
                <section className="pt-20">
                    <LanguageModels/>
                </section>
                <section className="cta-area section-spacing-bottom pt-20">
                    <FreeTrial/>
                </section>
                <section className="pt-20">
                    <OurPartners/>
                </section>
            </main>
        </>
    )
}
export default Landing